import { render } from "./upload-salary-step1.vue?vue&type=template&id=24e03be2&scoped=true&ts=true"
import script from "./upload-salary-step1.vue?vue&type=script&lang=ts"
export * from "./upload-salary-step1.vue?vue&type=script&lang=ts"

import "./upload-salary-step1.vue?vue&type=style&index=0&id=24e03be2&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e03be2"]])

export default __exports__